/**
 * 関連表示があるページの初期化
 */

import { waitForImagesLoad, adjustSlideButtonPosition, debounce } from './utils';

export function initRelated($) {
  if ($('.c-related').length === 0) return;

  // スライドボタン位置を動的に調整する関数
  function adjustRelatedButtonPosition() {
    $('.c-related .c-slide').each(function () {
      adjustSlideButtonPosition($(this), '.c-slide__item', '.c-slide__figure', { useTransform: true });
    });
  }

  // 関連スライド
  const relatedSlides = 3; // スライド数
  $('.c-related .c-slide')
    .on('init reInit', function () {
      // slick初期化完了後に位置調整
      setTimeout(adjustRelatedButtonPosition, 100);
    })
    .slick({
      slidesToShow: relatedSlides,
      slidesToScroll: 3,
      centerMode: false,
      infinite: true,
      arrows: true,
      dots: true,
      responsive: [{ breakpoint: 640, settings: { slidesToScroll: 2, slidesToShow: 2 } }],
    });

  // 現在のウィンドウ幅に応じた slidesToShow を取得
  function getCurrentSlidesToShow() {
    return $(window).width() < 640 ? 2 : 3;
  }

  // ドット・矢印の表示/非表示を制御
  function updateSlideControls() {
    const currentSlidesToShow = getCurrentSlidesToShow();

    $('.c-related .c-slide').each(function () {
      const $slide = $(this);
      const itemCount = $slide.find('.c-slide__item').length;
      const dotsCount = $slide.find('.slick-dots li').length;

      // スライド不要な場合（アイテム数が表示数以下、またはドットが1つしかない場合）
      if (itemCount <= currentSlidesToShow || dotsCount <= 1) {
        $slide.find('.slick-track').addClass('no-scroll');
        $slide.find('.slick-dots').hide();
        $slide.removeClass('slick-dotted');
      } else {
        $slide.find('.slick-track').removeClass('no-scroll');
        $slide.find('.slick-dots').show();
        $slide.addClass('slick-dotted');
      }

      // 2枚以下の場合は矢印も非表示（スマホで2列表示のため）
      if (itemCount <= 2) {
        $slide.find('.slick-prev, .slick-next').hide();
      } else {
        $slide.find('.slick-prev, .slick-next').show();
      }
    });
  }

  // 初期化後に実行
  updateSlideControls();

  // 画像読み込み完了を待って位置調整
  const $relatedImages = $('.c-related .c-slide__item img');
  waitForImagesLoad($relatedImages, adjustRelatedButtonPosition);

  // ウィンドウリサイズ時にボタン位置を再調整とスライドコントロールを更新
  const handleResize = debounce(() => {
    adjustRelatedButtonPosition();
    updateSlideControls();
  }, 200);

  $(window).on('resize', handleResize);
}
